"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const rxjs_1 = require("rxjs");
const https_1 = require("../https");
/**
 * Enhanced observable to track OTR transaction on Tangle / Build.5
 */
class Observable extends rxjs_1.Observable {
    constructor(origin, tag) {
        super((observer) => {
            this.observer = observer;
            this.dataset = (0, https_1.https)(origin).project(https_1.SoonaverseApiKey[origin]).dataset(interfaces_1.Dataset.TRANSACTION);
            this.observer.next({ status: 'waiting for payment' });
            this.subs['payment'] = this.dataset
                .getPaymentByTagLive(tag.startsWith('0x') ? tag : toHex(tag))
                .subscribe(async (payments) => {
                var _a;
                payments.sort((a, b) => { var _a, _b; return ((_a = a.createdOn) === null || _a === void 0 ? void 0 : _a.seconds) - ((_b = b.createdOn) === null || _b === void 0 ? void 0 : _b.seconds); });
                for (const payment of payments) {
                    if (!this.transactionIds.includes(payment.uid)) {
                        this.transactionIds.push(payment.uid);
                        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.next({
                            status: 'payment received',
                            chainReference: payment.payload.chainReference || '',
                        });
                        this.getResponseForPayment(payment);
                    }
                }
            });
            return this.closeConnection;
        });
        this.transactionIds = [];
        this.subs = {};
        this.getResponseForPayment = (payment) => {
            const obs = this.dataset.getBySourceTransactionLive(payment.uid);
            this.subs[payment.uid] = obs.subscribe((transactions) => {
                var _a, _b, _c;
                for (const tran of transactions) {
                    if (!this.transactionIds.includes(tran.uid)) {
                        this.transactionIds.push(tran.uid);
                        if (tran.type === interfaces_1.TransactionType.CREDIT_TANGLE_REQUEST) {
                            (_a = this.observer) === null || _a === void 0 ? void 0 : _a.next(Object.assign(Object.assign({}, tran.payload.response), { chainReference: ((_b = tran.payload.walletReference) === null || _b === void 0 ? void 0 : _b.chainReference) || '' }));
                            return;
                        }
                        if (tran.type === interfaces_1.TransactionType.UNLOCK) {
                            (_c = this.observer) === null || _c === void 0 ? void 0 : _c.next({ status: 'Success' });
                            return;
                        }
                    }
                }
            });
        };
        this.closeConnection = () => {
            var _a;
            Object.values(this.subs).forEach((subs) => subs.unsubscribe());
            (_a = this.observer) === null || _a === void 0 ? void 0 : _a.complete();
        };
    }
}
exports.Observable = Observable;
const toHex = (stringToConvert) => '0x' +
    stringToConvert
        .split('')
        .map((c) => c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');
